export const viewTime = (req, res) => {
  const hours = Math.floor(req / 60);
  const minutes = req - hours * 60;
  const hoursMinutes =
    String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0");
  if (hours === 0 && minutes === 0) {
    return "Midnight";
  }
  return hoursMinutes;
};

export const viewDuration = (req, res) => {
  const hours = Math.floor(req / 60);
  const minutes = req - hours * 60;
  const hoursMinutes =
    (hours === 1
      ? String(hours) + " hr "
      : hours > 1
      ? String(hours) + " hrs "
      : "") + (minutes > 0 ? String(minutes) + " mins " : "");
  if (hours === 0 && minutes === 0) {
    return "Midnight";
  }
  return hoursMinutes;
};
